module.exports = __webpack_public_path__ + "img/lecoslte2025-sample-badge.0261b8f5.png";